import type { JSX } from 'react';
import type { ChatAvatarUser } from '../../chatbot.types';
import { useChatUserAvatarViewModel } from './chat-user-avatar.viewmodel';

const UserSilhouette = (): JSX.Element => (
  <svg className='chatbot-avatar-silhouette' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='currentColor'>
    <path d='M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z' />
  </svg>
);

type Props = {
  user: ChatAvatarUser;
};

/**
 * Generic user avatar for the chatbot.
 * Resolves gravatar by email, falls back to initials or silhouette.
 */
export const ChatUserAvatar = ({ user }: Props): JSX.Element => {
  const [state, viewModel] = useChatUserAvatarViewModel(user);

  switch (state.variant.type) {
    case 'gravatar':
      return (
        <div className='chatbot-avatar chatbot-avatar--user'>
          <img src={state.variant.url} alt='User' className='chatbot-avatar-img' onError={viewModel.onGravatarError} />
        </div>
      );
    case 'initials':
      return (
        <div className='chatbot-avatar chatbot-avatar--user'>
          <span className='chatbot-avatar-initials'>{state.variant.text}</span>
        </div>
      );
    case 'silhouette':
      return (
        <div className='chatbot-avatar chatbot-avatar--user'>
          <UserSilhouette />
        </div>
      );
  }
};
